import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { WoodStatementService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  WoodStatementCreateDto,
  WoodStatementDto,
  WoodStatementExcelDownloadDto,
  WoodStatementUpdateDto,
} from '../proxy/planning/dtos/wood-statement';
import { WOODSTATEMENT_CONFIG, WOODSTATEMENT_FIELDS } from './wood-statement.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-wood-statement',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, WoodStatementService, ConfirmationService],
  templateUrl: './wood-statement.html',
  styleUrl: './wood-statement.scss',
})
export class WoodStatement extends BaseCrudComponent<
  WoodStatementDto,
  WoodStatementCreateDto,
  WoodStatementUpdateDto,
  WoodStatementExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(WoodStatementService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('WoodStatement', ids),
  };
  config = WOODSTATEMENT_CONFIG;
  fields = WOODSTATEMENT_FIELDS;

  protected prepareUpdateDto(data: any, selected: WoodStatementDto): WoodStatementUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'WoodStatement';
  }
}
